module.exports = __webpack_public_path__ + "static/img/logo1.7bdb70b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo1.png
// module id = TrFT
// module chunks = 1